import styled from "@emotion/styled";

export const StyledFormContainer = styled.div`
  max-width: 1024px;
  margin: 0 auto;

  .cases-title {
    font-weight: 500;
  }
  .header-action {
    gap: 8px;
  }
  .section-card {
    padding: 8px 10px;
    background: #f4f3f9;
    border-bottom: 1px solid #e5e2f0;
    color: #5c5470;
    margin-bottom: 0px;
    border-radius: 0px;
    .ant-form-item-label {
      padding: 0px;
    }
    .ant-form-item {
      margin-bottom: 5px;
    }
    .ant-form-item-explain-error {
      font-size: 12px;
    }
  }

  .form-section {
    /* Repeating instances styling */
    .forms-not-found {
      margin-top: 10px !important;
    }
    .repeating-instance {
      position: relative;
      padding-bottom: 16px;
      margin-bottom: 16px;
      border-bottom: 1px solid #e8e8e8;

      &:last-child {
        border-bottom: none;
        padding-bottom: 0;
        margin-bottom: 0;
      }

      .instance-header {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 16px;

        .instance-label {
          font-weight: 500;
          color: #262626;
          font-size: 14px;

          .instance-badge {
            display: inline-block;
            margin-left: 8px;
            padding: 2px 6px;
            background-color: #f6f8fb;
            border: 1px solid #d9d9d9;
            border-radius: 2px;
            font-size: 11px;
            color: #595959;
            font-weight: 500;
          }
        }

        .instance-actions {
          display: flex;
          gap: 8px;
        }
      }

      &.first-instance .instance-label .instance-badge {
        background-color: #e6f7ff;
        border-color: #91caff;
        color: #1677ff;
      }
    }

    .repeating-actions {
      display: flex;
      justify-content: center;
      margin-top: 16px;

      .add-instance-btn {
        &:disabled {
          opacity: 0.5;
          cursor: not-allowed;
        }
      }
    }

    /* Empty state */
    .empty-section {
      padding: 32px 16px;
      text-align: center;
    }
  }

  .ant-form-item-extra {
    color: #8c8c8c;
    font-size: 12px;
    margin-top: 4px;
    font-style: italic;

    display: flex;
    align-items: center;
    gap: 4px;

    &::before {
      content: "✨";
      font-size: 11px;
    }
  }
`;

export const StyledCreateCase = styled.div`
  .ctype-opt {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 10px 12px;
    background: #f4f3f9;
    border: 1px solid #e5e2f0;
    border-radius: 9px;
    cursor: pointer;
    margin-bottom: 7px;
    transition: all 0.15s;
    .ctype-icon {
      width: 34px;
      height: 34px;
      border-radius: 9px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 24px;
      flex-shrink: 0;
    }
    .ctype-info {
      flex: 1;
    }
    .ctype-name {
      font-size: 14px;
      font-weight: 500;
    }
    .ctype-desc {
      font-size: 12px;
      color: #5c5470;
    }
    &.selected {
      background: #f3effe;
      border-color: rgba(124, 58, 237, 0.3);
    }
  }
`;
